export default "__VITE_ASSET__mTyl$5_u__"